<template>
  <TTabsToggle
    :header="$t('forms.settings_element_social')"
    no-move
    :changed="wasChanged"
    data-testid="social-settings"
  >
    <menu-content-container border-full :padding-left-right="8">
      <content-row>
        <t-input-number
          v-model="iconSize.model"
          data-testid="icon-size"
          unit=""
          :label="$t('forms.social_size')"
          :changed="iconSize.changed"
          :reset-tooltip="$t('forms.reset_value')"
          @reset="iconSize.reset"
        ></t-input-number>
        <t-input-number
          v-model="iconPadding.model"
          data-testid="icon-padding"
          unit=""
          :label="$t('forms.padding_label')"
          :changed="iconPadding.changed"
          :reset-tooltip="$t('forms.reset_value')"
          @reset="iconPadding.reset"
        ></t-input-number>
      </content-row>
    </menu-content-container>

    <menu-content-container border-full :padding-left-right="8">
      <TLabel
        :changed="align.changed"
        :tooltip="$t('forms.reset_value')"
        @reset="align.reset"
        >{{ $t("forms.button_align") }}</TLabel
      >
      <content-row :margin-top="4">
        <TButtonGroup>
          <TGroupButton
            data="left"
            data-testid="align-left"
            medium
            :active="align.model === 'left'"
            @button-clicked="align.model = 'left'"
          >
            <AligmentLeft />
          </TGroupButton>
          <TGroupButton
            data="center"
            data-testid="align-center"
            medium
            :active="align.model === 'center'"
            @button-clicked="align.model = 'center'"
          >
            <AligmentCenter />
          </TGroupButton>
          <TGroupButton
            data="right"
            data-testid="align-right"
            medium
            :active="align.model === 'right'"
            @button-clicked="align.model = 'right'"
          >
            <AligmentRight />
          </TGroupButton>
        </TButtonGroup>
      </content-row>
    </menu-content-container>

    <padding-form
      data-testid="social-margin"
      :label="$t('forms.social_margin')"
      external-usage
      :external-padding="padding.model"
      :changed="padding.changed"
      :default-value="padding.defaultValue"
      :padding-left-right="8"
      @padding-changed="padding.model = $event"
      @reset="padding.reset"
    />
  </TTabsToggle>
</template>

<script setup lang="ts">
  import paddingForm from "@/forms/paddingForm.vue";
  import { useBlockAttr } from "@/composables/useBlockAttr";
  import { AligmentLeft, AligmentCenter, AligmentRight } from "@topol/icons";
  import {
    TTabsToggle,
    TInputNumber,
    TButtonGroup,
    TGroupButton,
    TLabel,
  } from "@topol/twig-ui";

  const { px, str, nullable, anyChanged } = useBlockAttr({
    mode: "global",
    block: "mj-social",
  });

  const iconSize = px("icon-size", 35);
  const iconPadding = px("icon-padding", 0);
  const align = str("align", "center");
  const padding = nullable("padding");

  const wasChanged = anyChanged(iconSize, iconPadding, align, padding);
</script>
